import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

export const salesAdminRouter: RouteRecordRaw[] = [
  {
    children: [
      {
        component: async () => import('../views/SalesAdminListView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'sales.dashboard',
        },
        name: 'admin.sales',
        path: '',
      },
      {
        component: async () => import('../views/SalesAdminBrandView.vue'),
        meta: {
          roles: ['pb:super'],
          title: 'sales.dashboard',
        },
        name: 'admin.sales.brand',
        path: 'brands/:brandId',
        props: (route: RouteLocationNormalized) => ({
          brandId: route.params.brandId,
        }),
      },
    ],
    component: async () => import('../views/SalesAdminView.vue'),
    meta: {
      roles: ['pb:super'],
    },
    path: 'admin/sales',
  },
]
